import { Component, OnInit } from '@angular/core';
import { formatDate, Location } from '@angular/common';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';

/** Parse a `yyyy-MM-dd` string as a local date (no UTC day shift). */
function parseYmd(value: string | null | undefined): Date | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value || '');
  return match ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3])) : null;
}

@Component({
    selector: 'app-return-date',
    templateUrl: './return-date.component.html',
    styleUrls: ['../picker.shared.css'],
    standalone: false
})
export class ReturnDateComponent implements OnInit {

  displayMonths = 12;
  today=new Date();
  minDate: Date = new Date();
  selected: Date | null = null;
  ngOnInit(): void {
    this.dataService.getTravelMessage().subscribe((date) => {
      this.minDate = parseYmd(date) ?? new Date();
    });
    // Open on the return date the traveller already has, if any.
    const current = parseYmd(this.dataService.returnValueMobile.value);
    if (current && current.getTime() >= this.minDate.getTime()) {
      this.selected = current;
    }
  }


  constructor(
    private router: Router,
    private dataService: DataService,
    private _location: Location
  ) {

  }



  cancel(): void {
    this._location.back();
  }

  onDateSelected(newDate: Date): void{
    this.selected = newDate;
    const date=formatDate(this.selected ,"yyyy-MM-dd","en-US");
    this.dataService.changeReturnMessage(date);
    this._location.back();
  }

}
